import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';

import { formatMoney, getMiddleIndexValue, getMaxMinAmountValue, objectToArrayKeepObject } from '../utils/utils.js';

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner.js';
import CustomSlider from './CustomSlider.js';
import ProductOption from './ProductOption.js'
import LeadInfo from './LeadInfo.js';

import 'rc-slider/assets/index.css';


require(`../assets/${process.env.PAGE}/css/custom-slider.css`);
require(`../assets/${process.env.PAGE}/css/components/product.css`);

class Product extends Component {
    constructor(props){
        super(props);

        this.state = {
            loan_quota: null,
            loan_quota_discounts: null,
            product_discounts: null,
            leadName: '',
            productUnselected: true,
            maxAmount: null,
            minAmount: null
        };
        this.selectProductOption = this.selectProductOption.bind(this);
        this.getProductWithDiscounts = this.getProductWithDiscounts.bind(this);
        this.handleSubmitSelectedProduct = this.handleSubmitSelectedProduct.bind(this);

    }

    componentWillMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/params`, config).then((response)=> {

            this.props.setDefaultValue({requested_amount: Object.keys(response.data.product)[getMiddleIndexValue(Object.keys(response.data.product))],
                                        requested_quotas: Object.keys(response.data.product[Object.keys(response.data.product)[getMiddleIndexValue(Object.keys(response.data.product))]])[0]})
            const { product, product_discounts } = response.data

            const isDiscount = product_discounts && Object.values(product_discounts).some(discounts => Object.values(discounts).some(value => value !== 0.0));

            this.setState({
                loan_quota: product,
                loan_quota_discounts: isDiscount ? this.getProductWithDiscounts(product, product_discounts) : null,
                maxAmount: getMaxMinAmountValue(product, 'max'),
                minAmount: getMaxMinAmountValue(product, 'min')
            });
        });
    }

    getProductWithDiscounts(products, discounts=null){
        if(!discounts){
            return null
        }
        const financing = {};
        for(const productKey in products) {
            if (products.hasOwnProperty(productKey)) {
                financing[productKey] = {};
                for(const installmentKey in products[productKey]) {
                  financing[productKey][installmentKey] = products[productKey][installmentKey] - discounts[productKey][installmentKey];
                }
              }
        }
        return financing
    }

    selectProductOption(quota, amountQuota){
        this.setState({productUnselected: false});
        this.props.dispatch(change(this.props.form, 'requested_quotas', quota));
    }

    handleSubmitSelectedProduct(){
        this.setState({productUnselected: true});
    }

    render() {
        const { handleSubmit, loan_amount_value, loan_quotas_value, clientName } = this.props;

        const { loan_quota_discounts, maxAmount, minAmount } = this.state;

        const selectedAmount = typeof(loan_amount_value) !== 'undefined' ? formatMoney(loan_amount_value, 0, ',', '.') : '';

        const minAmountAvailable = typeof(minAmount) !== 'undefined' ? formatMoney(minAmount, 0, ',', '.', false) : '';

        const maxAmountAvailable = typeof(maxAmount) !== 'undefined' ? formatMoney(maxAmount, 0, ',', '.', false) : '';

        let quotasStyle = {1: "col-md-12 col-lg-12 col-sm-12 col-xs-12", 2:  "col-md-6 col-lg-6 col-sm-6 col-xs-6", 3: "col-md-4 col-lg-4 col-sm-4 col-xs-4"  }

        const quotas = (this.state.loan_quota && loan_amount_value) &&
        (objectToArrayKeepObject(this.state.loan_quota[loan_amount_value])
        .map((product, index, array)=>{
            const quotaOption = Object.keys(product)[0]
            const amountQuotaOption = product[quotaOption]
            return (<div className={`${quotasStyle[array.length]} text-center no-gutters`} key={index}>
            <ProductOption  quotaOption={parseInt(quotaOption, 10)}
                            amountQuotaOption={parseInt(amountQuotaOption, 10)}
                            currentQuota={loan_quotas_value}
                            currentAmount={loan_amount_value}
                            isDiscount={loan_quota_discounts}
                            handleSubmitSelectedProduct={this.handleSubmitSelectedProduct}
                            onClick={this.selectProductOption}
                            gaEvent="true"
                            gaCategory="FunnelSteps"
                            gaAction="ProductSelected"
                            gaValue={loan_amount_value}
                            gaLabel="Btn-10000a-12c" />
            </div>)
        }))

        const quotasDiscount = (loan_quota_discounts && loan_amount_value) &&
        (objectToArrayKeepObject(loan_quota_discounts[loan_amount_value])
        .map((product, index, array)=>{
            const quotaOption = Object.keys(product)[0]
            const amountQuotaOption = product[quotaOption]
            return (<div className={`${quotasStyle[array.length]} text-center no-gutters`} key={index}>
            <ProductOption  quotaOption={parseInt(quotaOption, 10)}
                            amountQuotaOption={parseInt(amountQuotaOption, 10)}
                            currentQuota={loan_quotas_value}
                            currentAmount={loan_amount_value}
                            handleSubmitSelectedProduct={this.handleSubmitSelectedProduct}
                            onClick={this.selectProductOption}
                            gaEvent="true"
                            gaCategory="FunnelSteps"
                            gaAction="ProductSelected"
                            gaValue={loan_amount_value}
                            gaLabel="Btn-10000a-12c" />
            </div>)
        }))


        return (

             <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_product" description="Product info" values={{ nameClient: clientName, }} />
                            <FormattedHTMLMessage id="app.step_product_description" description="Product step description" values={{ maxAmount: maxAmountAvailable, }} />
                        </div>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.addProduct)} className="pvc-form">
                         {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                         <div className="row text-center">
                                <h3 className="help-font">Seleccioná el Monto y las Cuotas, y obtené tu adelanto en el día</h3>
                            </div>
                            <Field name="requested_amount"
                                component={CustomSlider}
                                productList={this.state.loan_quota && Object.keys(this.state.loan_quota)}
                                initialValue={loan_amount_value}
                            />
                            <div className="row">
                                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-left no-gutters amounts-available">
                                    {minAmountAvailable}
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 text-center">
                                    <div className="pd-slider-labels text-center">
                                        <p className="pd-slider-value">{selectedAmount}</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-right no-gutters amounts-available">
                                    {maxAmountAvailable}
                                </div>
                            </div>
                            {this.state.loan_quota && (<div className="row">{quotas}</div>)}
                            {loan_quota_discounts && (
                                <div>
                                    <div className="row text-center">
                                        <p className="pd-slider-preference-description">¡Aprovechá el monto preferencial!</p>
                                    </div>
                                    <div className="row text-center">{quotasDiscount}</div>
                                </div>)}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={this.state.productUnselected}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

Product.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('product')

Product = connect(
    state => {
        const loan_amount_value = selector(state, 'requested_amount')
        const loan_quotas_value = selector(state, 'requested_quotas')
        return {
            loan_amount_value,
            loan_quotas_value,
        }
    }
)(Product)

Product = TopScrolleable(Product);

Product = reduxForm({
    form: 'product', // a unique name for this form
})(Product);

Product = LeadInfo(Product);

Product = withAuthControl(Product);

export default Product;



/** WEBPACK FOOTER **
 ** ./src/components/Product.js
 **/